module.exports = "<app-nav></app-nav>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// /var/www/html/mediate/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main